// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"f44f8923","731":"feb9b923","905":"dc0b6d03"}[chunkId] + ".chunk.js";
};